import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Privacy from "./Pages/Privacy";
import Terms from "./Pages/Terms";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/terms-and-conditions" element={<Terms />} />
        <Route path="*" element={<Navigate to="/privacy-policy" />} />
      </Routes>
    </Router>
  );
};

export default App;
